import React from 'react';
import GoogleLoginButton from './GoogleLoginButton';

export default function SignupForm() {
  return (
    <div>
      <GoogleLoginButton buttonText="Registrarse con Google" />
      
      <p style={{ 
        fontSize: '0.9em', 
        color: 'gray', 
        marginTop: '1em', 
        textAlign: 'center' 
      }}>
        Al crear una cuenta, aceptas nuestros{' '}
        <a href="/terms" target="_blank" rel="noopener noreferrer">
          términos de servicio
        </a>
      </p>
    </div>
  );
} 